export const roles = {
  MissingEmail: 'MissingEmail',
  MissingMobile: 'MissingMobile',
  Onboarding: 'Onboarding',
  MissingWorkSituation: 'MissingWorkSituation',
  Arbetsgivarinfo: 'Arbetsgivarinfo',
  TIOOprovad: 'TIOOprovad',
  TIOAktiv: 'TIOAktiv',
  TIAOprovad: 'TIAOprovad',
  TIAAktiv: 'TIAAktiv',
} as const
